module.exports = __webpack_public_path__ + "img/Weapon_271.3369fc8d.png";